import React from 'react'
import CountDownTimer from './CountDownTimer';

function Maintenance() {
  return (
    <div className="pt-5 w-[98vw] items-center">
      <div className="justify-center text-rose-800 font-bodyFont">
        <p className="text-center font-bold text-lg tracking-wide">
          Shopsyi is under server maintenance!
        </p>
        <p className="text-center font-medium text-lg">
          sorry for your inconvenience
        </p>
        <p className="text-center font-medium text-base">
          We'll be back within
        </p>
        <p className="text-center mx-auto font-bold tracking-widest rounded-lg border-2 border-rose-200 bg-rose-100 h-8 pt-0.5 w-24 mt-1">
        <CountDownTimer />
        </p>
      </div>
    </div>
  );
}

export default Maintenance